import * as React from 'react';

import { MyInvoicesPrivatePage } from '@/components/PrivatePages/MyInvoicesPrivatePage/MyInvoicesPrivatePage';
import { useInvoices } from '@/features/invoices';

export const MyInvoicesPage = () => {
  const invoicesQuery = useInvoices({});

  const { isLoading: invoicesIsLoading = false, data: invoices } = invoicesQuery;

  return <MyInvoicesPrivatePage invoices={invoices || []} loading={invoicesIsLoading} />;
};
